async function twoGuysAddWishlistUPC() {
  const products = document.querySelectorAll(".Vtl-WishlistProduct");

  for (const card of products) {
    if (card.querySelector(".two-guys-wishlist-upc")) continue;

    const link = card.querySelector('a[href*="/products/"]');
    if (!link) continue;

    const url = new URL(link.href);
    const productJsonUrl = `${url.pathname}.js`;

    try {
      const res = await fetch(productJsonUrl);
      const product = await res.json();

      const sku = product?.variants?.[0]?.sku;

      if (!sku) continue;

      const upc = document.createElement("div");
      upc.className = "two-guys-wishlist-upc";
      upc.textContent = `UPC: ${sku}`;

     const price = card.querySelector('[class*="Price"]');
if (price) {
  price.insertAdjacentElement("beforebegin", upc);
} else {
  link.insertAdjacentElement("afterend", upc);
}
    } catch (e) {
      console.warn("Cannot load UPC", e);
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(twoGuysAddWishlistUPC, 1000);
});

document.addEventListener("shopify:section:load", () => {
  setTimeout(twoGuysAddWishlistUPC, 1000);
});
function twoGuysEmptyWishlistLayout() {
  const emptyBox = document.querySelector(".Vtl-WishlistPage__EmptyList");
  if (!emptyBox) return;

  if (emptyBox.querySelector(".two-guys-empty-login")) return;

  const subtitle = document.createElement("div");
  subtitle.className = "two-guys-empty-subtitle";
  subtitle.textContent = "Explore our newest arrivals and save your favorites.";

  const login = document.createElement("a");
  login.className = "two-guys-empty-login";
  login.href = "/account/login";
  login.textContent = "Log in to begin";

  emptyBox.appendChild(subtitle);
  emptyBox.appendChild(login);
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(twoGuysEmptyWishlistLayout, 800);
});